import { OptionsWithoutBackground } from "src/routes/onboarding/shared/components/optionsWithoutBackground";
import background from "./bg.png";

const data = [
  {
    displayValue: "I fell asleep and woke up easily",
    value: "I fell asleep and woke up easily",
  },
  {
    value: "I occasionally toss and turn at night",
    displayValue: "I occasionally toss and turn at night",
  },
  {
    value: "I don’t feel rested after sleeping",
    displayValue: "I don’t feel rested after sleeping",
  },
  {
    value: "I can’t fall or stay asleap",
    displayValue: "I can’t fall or stay asleap",
  },
];

export const GoodNightSleep = ({ onNextStep, onTrackEvent }) => {
  const handleNextStep = (v) => {
    onNextStep?.();
    onTrackEvent?.(v.displayValue);
    localStorage.setItem("GoodNightSleep", v.value); // ?
  };
  return (
    <OptionsWithoutBackground
      isWalky={true}
      data={data}
      title="Struggling to get a good night's sleep?"
      onClick={handleNextStep}
      background={background}
    />
  );
};
